import Image from "next/image";
import "./hospitalCard.scss";
import Link from "next/link";
import { routeName } from "@/utils/commonfuntions";
import { useIntl } from "react-intl";
import { useMemo } from "react";

export default function HospitalCardWithApi({ hospital, quoteBtn = false }) {
  const intl = useIntl();

  // Memoize route generation logic
  const hospitalSlug = useMemo(() => {
    // Check if hospital has attributes (API format) or direct properties
    const isApiFormat = !!hospital?.attributes;
    const slug = isApiFormat ? hospital?.attributes?.name : hospital?.slug || hospital?.name;
    return routeName(slug);
  }, [hospital]);

  // Memoize hospital data - handle both direct data and API response format with attributes
  const hospitalData = useMemo(() => {
    // Check if hospital has attributes (API format) or direct properties
    const isApiFormat = !!hospital?.attributes;
    return {
      name: isApiFormat ? hospital?.attributes?.name : hospital?.name,
      imageUrl: isApiFormat
        ? hospital?.attributes?.image?.data?.attributes?.url
        : hospital?.img?.url,
      address: isApiFormat ? hospital?.attributes?.location : hospital?.address,
      place: isApiFormat ? hospital?.attributes?.location : hospital?.place,
    };
  }, [hospital]);

  // Memoize the free quote text
  const freeQuoteText = useMemo(
    () => intl.formatMessage({ id: "get_free_quote" }),
    [intl],
  );

  // Memoize the component rendering
  return useMemo(
    () => (
      <Link
        href={{
          pathname: `/hospitals/${hospitalSlug}`,
        }}
      >
        <div className="hospitalWrapper">
          <div className="hospitalContainer hover:shadow-lg transition-all duration-300">
            <Image
              loading="lazy"
              src={hospitalData.imageUrl}
              alt="hospital image"
              fill
              style={{ objectFit: "cover" }}
            />
            <div className="hospitalInfoContainer ">
              <div className="hospitalInfo">
                <div className="h-[120px]">
                  <p className="hospitalName">{hospitalData.name}</p>
                  <p className="hospitalPlace">{hospitalData.place}</p>
                  <p className="hospitalAddress">{hospitalData.address}</p>
                </div>

                {quoteBtn && (
                  <div className="quoatationBtn">{freeQuoteText}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Link>
    ),
    [hospitalSlug, hospitalData, freeQuoteText, quoteBtn],
  ); // Dependencies for memoization
}
